import imageUrlBuilder from '@sanity/image-url';
import { useRootLoaderData } from '~/hooks/useRootLoaderData';
import type { GetSanityImageUrlOptions } from './getSanityImageUrl.types';

/**
 * Build an image URL from a Sanity image reference. Sets a default quality, and
 * format for image optimization.
 *
 * @docs https://www.sanity.io/docs/image-url
 */
export const useSanityImageUrl = ({
  format = 'webp',
  height,
  imageObject,
  quality = 70,
  width,
}: GetSanityImageUrlOptions) => {
  const {
    publicEnv: { SANITY_DATASET, SANITY_PROJECT_ID },
  } = useRootLoaderData();

  if (!imageObject) {
    return undefined;
  }

  let builder = imageUrlBuilder({ dataset: SANITY_DATASET, projectId: SANITY_PROJECT_ID }).image(imageObject);

  if (width) {
    builder = builder.width(width);
  }

  if (height) {
    builder = builder.height(height);
  }

  // Generate the image URL with transform options, `url()` must be called last.
  return builder.fit('max').quality(quality).format(format).url();
};
